import React from "react";
import {
  Header as TemplateHeader,
  SubHeading as TemplateSubHeading,
  Description as TemplateDescription,
} from "../Typography/typography.styled";
import styled from "styled-components";
import { Col, Container, Row } from "react-bootstrap";
import heroScreenshotImageSrc from "../../images/hero-screenshot-1.png";
import waveHaikel from "../../images/wave-haikei-2.svg";

import AuthorPicture2 from "../../images/author-picture-2.png";

const PrimaryContainer = styled.div`
  aspect-ratio: 963/300;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  background-image: url(${waveHaikel});
`;

const ContainerXLPadding = styled(Container)`
  padding-bottom: 6rem;

  @media (min-width: 1024px) {
    padding-top: 8rem;
    padding-bottom: 8rem;
  }
`;

const Header = styled(TemplateHeader)`
  margin-top: 1rem;
  font-size: 1.875rem;
  line-height: 2.25rem;
  line-height: 2.5rem;
  font-weight: 900;
  letter-spacing: 0.025em;
  line-height: 1.25;
  text-align: left;
  text-align: center;
  color: white;

  @media (min-width: 640px) {
    font-size: 2.25rem;
    line-height: 2.5rem;
    line-height: 1;
  }
  @media (min-width: 768px) {
    text-align: left;
  }
  @media (min-width: 1024px) {
    font-size: 3rem;
    line-height: 3.5rem;
  }
`;

const Subheading = styled(TemplateSubHeading)`
  text-align: center;
  text-transform: uppercase;
  color: #6415ff;
  letter-spacing: 0.1rem;
  font-size: 1rem;
  margin-top: 4rem;

  @media (min-width: 768px) {
    text-align: left;
    margin-top: 0rem;
  }
`;

const Description = styled(TemplateDescription)`
  margin-top: 1rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 500;
  line-height: 1.625;
  text-align: center;
  color: rgb(124, 139, 161);

  @media (min-width: 768px) {
    font-size: 1rem;
    line-height: 1.5rem;
    text-align: left;
  }
  @media (min-width: 1024px) {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }
`;

const TextContent = styled.div`
  text-align: center;

  @media (min-width: 768px) {
    margin-left: ${(props) => (props.textOnLeft ? "0rem" : "3rem")};
    margin-right: ${(props) => (props.textOnLeft ? "3rem" : "0rem")};
    text-align: start;
  }
  @media (min-width: 1024px) {
    margin-left: ${(props) => (props.textOnLeft ? "0rem" : "3rem")};
    margin-right: ${(props) => (props.textOnLeft ? "3rem" : "0rem")};
  }
`;

const ImageContent = styled.img`
  aspect-ratio: 600/600;
`;

const TextColumn = styled(Col)`
  display: flex;
  align-items: start;

  @media (min-width: 720px) {
    align-items: center;
  }
`;

const AboutMe = ({
  subheading = "Quality Work",
  heading = "About Me",
  description = "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. ",
  imageSrc = heroScreenshotImageSrc,
  textOnLeft = false,
}) => {
  return (
    <PrimaryContainer>
      <ContainerXLPadding style={{ background: "#6415ff" }}>
        <Container>
          <Row xs={1} md={2} className="mx-2 mx-md-0">
            <Col
              xs={(12, { order: "first" })}
              md={(6, { order: textOnLeft ? "last" : "first" })}
              className="d-flex justify-content-center align-items-center"
            >
              <div>
                <img src={AuthorPicture2} className="img-fluid" />
              </div>
            </Col>
            <TextColumn
              xs={(12, { order: "last" })}
              md={(6, { order: textOnLeft ? "first" : "last" })}
            >
              <TextContent textOnLeft={textOnLeft}>
                <Subheading>{subheading}</Subheading>
                <Header>{heading}</Header>
                <Description>{description}</Description>
              </TextContent>
            </TextColumn>
          </Row>
        </Container>
      </ContainerXLPadding>
    </PrimaryContainer>
  );
};

export default AboutMe;
